import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import { API_ADDRESS } from 'config'
import { checkToken } from 'utils/functions'
import { Button, Menu, Menu as AntMenu } from 'antd'
import { NavLink, useLocation } from 'react-router-dom'
import { IconModule } from '../Icons'
import links from './config'
import { useUsers } from '../../state/users/hooks'

// const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null

const { SubMenu } = Menu

interface IconProps {
  size: string
}

const Icons = IconModule as unknown as { [key: string]: React.FC<IconProps> }

type MenuItemsProps = {
  setMenuVisible: any
}

const MenuItems = ({ setMenuVisible } : MenuItemsProps) => {
  const location = useLocation()
  const pages = []
  // const data = useUsers()
  const [menuLinks, setMenuLinks] = useState(links)
  const [userData, setUserData] = useState([])
  const [pageRefreshed, setPageRefreshed] = useState(false)

  // Hide users option for non Super Admins
  //   if (data.isAdmin) {
  //     links.forEach((item, index) => {
  //       if (item.id !== 24) {
  //         links.splice(index, 1)
  //       }
  //     })
  //     // links[0].subMenuItems.splice(1, 1)
  //   }

  links.forEach((link) => {
    if (link.subMenuItems) {
      link.subMenuItems.forEach((subItem) => pages.push(subItem))
    } else {
      pages.push(link)
    }
  })
  const selectedKeys = pages.filter((link) => link.path === location.pathname).map((link) => link.id.toString())

  const getUserDetails = useCallback(() => {
    const abortController = new AbortController()

    try{

      const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null

      if ( tokenData ){
        const config = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tokenData.token}`,
          },
          signal: abortController.signal,
        }

        fetch(`${API_ADDRESS}/users/assigned-stats`, config)
        .then( response => response.json() )
        .then( data => {
            checkToken(data)

            const user = data.find( next => next._id === tokenData._id )
            setUserData(user)

            // Lock these to Super Admin
            const superAdminPages = [
                '/list-users'
            ]

            const approvedLinks = links.filter( link => 
              // Super Admin
              ( user.role === 'Admin' && user.isAdmin === true)
              ||
              ( user.role === 'Admin' && user.isAdmin !== true && !superAdminPages.includes(link.path) )
              // Editor
              || ( user.role === 'Editor' && (link.path === '/' || link.path === '/assigned-listings') )
            )

            setMenuLinks(approvedLinks)
            if ( tokenData?.refreshed === true ){
              // ..already refreshed page
            }else{
              const newTokenData = {
                ...tokenData,
                refreshed: true,
              }
              localStorage.setItem('bba-token',JSON.stringify(newTokenData))
              window.location.href='/'
            }
        })
        .catch( error => {
          if ( error.name === 'AbortError'){
            // ...
          }
        })
      }
    } catch(error) {
      abortController.abort()
    }
  },[])

  useEffect(() => {
    const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
    if( tokenData ){
      getUserDetails()
    }
    return () => {
      // ... 
    }
  },[getUserDetails])

  return (

    <AntMenu mode="inline" selectedKeys={selectedKeys} style={{ height: '90%', overflowY: 'auto',  borderRight: 0}} theme="dark">
      {menuLinks?.length > 0 && menuLinks.map((entry) => {
        const Icon = Icons[entry.icon]
        if (entry.path) {
          return (
            <Menu.Item
              key={entry.id}
              icon={<Icon size={entry.iconSize} />}
              title={entry.name}
              style={{
                paddingLeft: 16,
                paddingRight: 16,
                fontSize: 16,
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <NavLink exact to={entry.path} style={{ marginLeft: 4 }} onClick={(e) => {if (setMenuVisible) {setMenuVisible(false)}}}>
                {entry.name}
              </NavLink>
            </Menu.Item>
          )
        }
        return (
          <SubMenu
            key={entry.id}
            icon={<Icon size={entry.iconSize} />}
            title={entry.name}
            style={{ paddingLeft: 0, fontSize: 15, marginBottom: 8 }}
          >
            {entry.subMenuItems.map((subItem) => {

				if (subItem.path.indexOf('http') > -1){
					  return (
						<Menu.Item key={subItem.id} title={subItem.name}>
							<a href={subItem.path} target="_blank" rel="noreferrer noopener" onClick={(e) => {if (setMenuVisible) {setMenuVisible(false)}}}>{subItem.name}</a>
						</Menu.Item>
					  )
				}
				  return (
					<Menu.Item key={subItem.id} title={subItem.name}>
					  <NavLink to={subItem.path} style={{ marginLeft: 4 }} onClick={(e) => {if (setMenuVisible) {setMenuVisible(false)}}}>
						{subItem.name}
					  </NavLink>
					</Menu.Item>
				  )
				
            })}
          </SubMenu>
        )
      })}
    </AntMenu>

  )
}

export default MenuItems
